
  /* ------------------------------------------------------
Product Library (Single Source of Truth)
------------------------------------------------------ */

const productLibrary = {

  acneCleanser: {
    productHandle: "hyphen-clarifying-acne-cleanser",
    info: "Washes away excess oil and acne-causing impurities.",
    ingredients: "Salicylic Acid",
    ingredientInfo: [
      "Gently exfoliates skin",
      "Unclogs pores",
      "Removes impurities"
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Take pump size amount",
      "Massage gently for 30 seconds on wet skin",
      "Rinse thoroughly and pat dry"
    ]
  },

  brighteningCleanser: {
    productHandle: "rice-water-brightening-daily-cleanser",
    info: "Removes impurities for a healthy glow.",
    ingredients: "Fermented Rice Water",
    ingredientInfo: [
      "Even-tones skin",
      "Makes it clearer with use",
      "Enhances glow"           
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Take pump size amount",
      "Massage gently for 30 seconds on wet skin",
      "Rinse thoroughly and pat dry"
    ]
  },

  moisturizingCleanser: {
    productHandle: "moisturizing-creamy-cleanser-mildly-cleanses-non-drying-100ml",
    info: "Mildly cleanses, maintains skin's pH balance",
    ingredients: "Ceramides",
    ingredientInfo: [
      "Nourishes skin",
      "Prevents moisture loss",
      "Keeps skin moisturized and supple"                          
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Take pump size amount",
      "Massage gently for 30 seconds on wet skin",
      "Rinse thoroughly and pat dry"
    ]
  },

  exfoliatingCleanser: {
    productHandle: "oil-control-daily-exfoliating-cleanser-gently-exfoliates-makes-skin-oil-free-100-ml",
    info: "Gently exfoliates, removes impurities & excess oil",
    ingredients: "AHA-BHA",
    ingredientInfo: [
      "Gently Exfoliates",
      "Unclogs pores" ,
      "Removes dead skin"            
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Take pump size amount",
      "Massage gently for 30 seconds on wet skin",
      "Rinse thoroughly and pat dry"
    ]
  },

  acneSerum: {
    productHandle: "acne-defence-daily-serum",
    info: "Treats active acne, soothes and calms skin, prevents future breakouts",
    ingredients: "Azelaic Acid",
    ingredientInfo: [
      "Helps prevent future breakouts",
      "Kills acne causing bacteria",
      "Improves skin texture"
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Pat 1-2 pumps of serum.",
      "Apply on face and neck.",
      "Pat until absorbed."
    ]
  },

  glowSerum: {
    productHandle: "golden-hour-glow-face-serum",
    info: "A serum for daily glow which helps fade dark spots and reduces skin dullness",
    ingredients: "Niacinamide",
    ingredientInfo: [
      "Reduces dark spots",
      "Helps with even skin tone",
      "For daily glow"
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Apply 2-3 pumps on face & neck,massage until absorbed."
    ]
  },

  retinalSerum: {
    productHandle: "0-05-retinal-reset-serum-beginner-friendly",
    info: "Minimizes signs of ageing More effective than Retinol",
    ingredients: "Encapsulated Retinal",
    ingredientInfo: [
      "Penetrates skin to promote cell regeneration",
      "Reduces fine lines, wrinkles"
    ],
    recomdLine: "",
    frequency: "PM",
    howToUse: [
      "Apply 1-2 pumps on cleansed skin.",
      "Start with using twice a week.",
      "Use moisturizer after.",
      "Use SPF next day in the morning"
    ]
  },

  vitcSerum: {
    productHandle: "10-vitamin-c-serum-with-1-vitamin-e-ferulic-acid-clinically-tested",
    info: "Beginner friendly serum that helps brighten and reduce dark spots",
    ingredients: "10% Vitamin C",
    ingredientInfo: [
      "More stabilized with 1% Vitamin E + Ferulic Acid",
      "Penetrates deeply into the skin For brighter, more even toned skin"
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Apply 1-2pumps, as per your requirement on clean dry skin.",
      "Follow up with SPF in the morning"
    ]
  },

  depigSerum: {
    productHandle: "advanced-de-pigmentation-serum",
    info: "Visibly fades dark spots, for brighter and glowing skin",
    ingredients: "3% Tranexamic Acid",
    ingredientInfo: [
      "Helps fade dark spots",
      "Reduces melasma",
      "Helps fade discoloration"
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Pat 1-2 pumps on cleansed face",
      "If new to actives, start by using 1-2 times a week"
    ]
  },

  powpepSerum: {
    productHandle: "copper-peptide-cocktail-serum",
    info: "Helps smooth fine lines & wrinkles",
    ingredients: "2% Copper Peptide",
    ingredientInfo: [
      "Mimics naturally ocurring peptides in the skin",
      "Strengthens skin and improves it's texture",
      "Boosts collagen"
    ],
    recomdLine: "",
    frequency: "AM",
    howToUse: [
      "Apply 1-2 pumps on cleansed skin.",
      "Use SPF in the morning.",
      "Use Retinal 0.05% at night for better results."
    ]
  },

  milkytonSerum: {
    productHandle: "hydrating-ceramide-toner-essence",
    info: "Instant hydration, that repairs skin barrier",
    ingredients: "NMF + 5 essential ceramides",
    ingredientInfo: [
      "Deeply hydrates skin",
      "Repairs & strengthens skin barrier"              
    ],
    recomdLine: "",
    frequency: "AM & PM",
    howToUse: [
      "Take a generous amount, pat until absorbed."
    ]
  },

  oilfreeMoisturizer: {
    productHandle: "oil-free-moisturizer",
    info: "Gives lightweight hydration Doesn't clog pores Balances oil production",
    ingredients: "Cica Exosomes",
    ingredientInfo: [
      "10X deep cellular level hydration",
      "Helps other ingredients absorb better into skin's layer"
    ],
    recomdLine: "",
    frequency: "If skin feels dry",
    howToUse: [
      "Take 1-2 pea sized amount and apply on skin after serum.",
      "Use sunscreen after, in AM"
    ]
  },

  barrepNDMoisturizer: {
    productHandle: "barrier-care-face-cream-dry-skin",
    info: "To moisturize and soothe normal to dry skin types",
    ingredients: "2% Ceramide-Peptide Complex",
    ingredientInfo: [
      "Repairs & Strengthens skin barrier",
      "Helps retain moisture",
      "Plumps and makes skin supple"
    ],
    recomdLine: "",
    frequency: "PM",
    howToUse: [
      "Take 1-2 pumps and apply evenly on face and neck."
    ]
  },

  barrepOCMoisturizer: {
    productHandle: "barrier-care-cream-oily-skin",
    info: "To moisturize and soothe oily to combination skin types",
    ingredients: "2% Ceramide-Peptide Complex",
    ingredientInfo: [
      "Repairs & Strengthens skin barrier",
      "Helps retain moisture",
      "Plumps and makes skin supple"
    ],
    recomdLine: "",
    frequency: "PM",
    howToUse: [
      "Take 1-2 pumps and apply evenly on face and neck."
    ]
  },

  cerpiloMoisturizer: {
    productHandle: "ceramide-rich-pillow-cream",
    info: "Provide rich intense moisturization to dry skin.",
    ingredients: "Ceramides+Natural Moisturizing Factors (NMF)",
    ingredientInfo: [
      "Improve skin barrier function",
      "Help in retaining moisture"
    ],
    recomdLine: "",
    frequency: "PM",
    howToUse: [
      "Take a little amount and massage into skin"
    ]
  },

  ssmSunscreen: {
    productHandle: "sun-milk-100-mineral-sunscreen-spf-50-pa",
    info: "Provides UV protection without generating heat on skin.",
    ingredients: "Nano-Zinc Oxide",
    ingredientInfo: [
      "Broad spectrum UV protection",
      "Gentle and non-irritating for sensitive skin & acne-prone skin"
    ],
    recomdLine: "",
    frequency: "AM",
    howToUse: [
      "Take 1-2 finger length sunscreen.",
      "Apply on face & neck.",
      "Use 15 mins before sun exposure"
    ]
  },

  ainSunscreen: {
    productHandle: "all-i-need-sunscreen-spf-50",
    info: "Brightens, moisturizzes and protects skin",
    ingredients: "5 Essential Ceramides",
    ingredientInfo: [
      "Strengthens skin barrier",
      "Moisturizes while providing sun protection"
    ],
    recomdLine: "",
    frequency: "AM",
    howToUse: [
      "Take 1-2 finger length sunscreen.",
      "Apply on face & neck.",
      "Use 15 mins before sun exposure"
    ]
  },

  fcSunscreen: {
    productHandle: "cooling-sunscreen",
    info: "6X better sun protection",
    ingredients: "Encapsulated New Gen UV filters [Tinosorb and Uvinul]",
    ingredientInfo: [
      "Helps with enhanced photostabilty",
      "Enhanced sun protection by providing even coverage"
    ],
    recomdLine: "",
    frequency: "AM",
    howToUse: [
      "Apply generously to the face & neck 15 minutes before sun exposure."
    ]
  },

  ulwSunscreen: {
    productHandle: "ultra-light-water-sunscreen-spf-50-pa",
    info: "New Age UV filters for advanced sun protection, Protects from blue light as well free and radical damage",
    ingredients: "1% Hyaluronic Acid",
    ingredientInfo: [
      "1% Hyaluronic Acid in four molecular weights, to hydrate even the deepest skin layers"
    ],
    recomdLine: "",
    frequency: "AM",
    howToUse: [
      "Take 1-2 finger length sunscreen.",
      "Apply on face & neck.",
      "Use 15 mins before sun exposure"
    ]
  }

};



/* ------------------------------------------------------
Optimized Routine Mapping
------------------------------------------------------ */

const routineMapping = {

  "13-19_normal_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_normal_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_normal_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_normal_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_normal_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "acneSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "glowSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_combination_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_combination_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_dry_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_dry_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_dry_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_dry_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_dry_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_oily_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_oily_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_oily_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_oily_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_oily_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "13-19_sensitive_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_sensitive_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_sensitive_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "13-19_sensitive_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_sensitive_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_sensitive_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_normal_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_combination_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "13-19_dry_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_normal_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_normal_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_normal_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_normal_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_normal_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_normal_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_normal_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_normal_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_normal_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "20-30_normal_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_normal_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "20-30_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "fcSunscreen"
    }
  },

  "20-30_combination_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_combination_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_combination_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_combination_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_dry_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_dry_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_dry_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_dry_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_dry_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "20-30_dry_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_dry_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_dry_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_dry_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_dry_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_dry_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "fcSunscreen"
    }
  },

  "20-30_oily_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_oily_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_oily_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_oily_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_oily_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_sensitive_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_sensitive_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_sensitive_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "20-30_sensitive_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_sensitive_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "20-30_sensitive_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_sensitive_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_sensitive_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_sensitive_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_sensitive_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "20-30_sensitive_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "20-30_sensitive_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_normal_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_combination_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "20-30_dry_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_normal_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_normal_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_normal_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_normal_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "fcSunscreen"
    }
  },

  "31-40_normal_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_normal_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_normal_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_normal_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_normal_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_normal_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_normal_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "31-40_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "fcSunscreen"
    }
  },

  "31-40_combination_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_combination_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_combination_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_combination_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_dry_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_dry_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_dry_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_dry_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_dry_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "31-40_dry_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_dry_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_dry_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_dry_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "31-40_dry_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "31-40_dry_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_oily_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "depigSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "fcSunscreen"
    }
  },

  "31-40_oily_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "vitcSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_oily_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_oily_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_oily_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_oily_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "retinalSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_sensitive_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_sensitive_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_sensitive_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "31-40_sensitive_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_sensitive_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },


   "31-40_sensitive_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_sensitive_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_sensitive_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_sensitive_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_sensitive_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "31-40_sensitive_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "31-40_sensitive_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_normal_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_combination_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "31-40_dry_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_normal_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_normal_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_normal_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_normal_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_normal_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_normal_glow_Dullness": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_normal_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_normal_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_normal_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_normal_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_normal_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_combination_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_combination_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_combination_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_combination_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_combination_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_combination_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_dry_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_dry_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_dry_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_dry_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_dry_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_dry_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_dry_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_dry_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_dry_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_dry_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_dry_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_oily_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_oily_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

   "40+_oily_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_oily_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_oily_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_oily_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "exfoliatingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepOCMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_sensitive_acne_Excess Oil,Frequent Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_sensitive_acne_Occasional Breakouts": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_sensitive_acne_Painful / Inflammatory Pimples": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "acneCleanser",
      Serum: "acneSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ssmSunscreen"
    }
  },

  "40+_sensitive_pigmentation_Dark Spots & Marks": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "depigSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_sensitive_pigmentation_Uneven Skin Tone": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "vitcSerum",
      Moisturizer: "oilfreeMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },


   "40+_sensitive_glow_Dullness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_sensitive_glow_Uneven Texture": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "glowSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_sensitive_ageing_Early Fine Lines": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_sensitive_ageing_Fine lines & Wrinkles": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_sensitive_ageing_Sagging Skin": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

   "40+_sensitive_ageing_Well ageing": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "powpepSerum",
      Moisturizer: "barrepNDMoisturizer",
      Sunscreen: "ulwSunscreen"
    }
  },

  "40+_sensitive_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_normal_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_combination_dryness_Occasional Dryness": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "brighteningCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

  "40+_dry_dryness_Dehydration": {
    steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
    products: {
      Cleanser: "moisturizingCleanser",
      Serum: "milkytonSerum",
      Moisturizer: "cerpiloMoisturizer",
      Sunscreen: "ainSunscreen"
    }
  },

};

